import { combineReducers } from '@reduxjs/toolkit';
import vehicles from './slice';

export default combineReducers({
  $: vehicles
});